// extracted by mini-css-extract-plugin
export default {"heading":"Causes_heading__RzhoY"};